import React, { ReactNode } from 'react';
import Skeleton from 'react-loading-skeleton';
import styled, { css, keyframes } from 'styled-components';

const SkeletonComponent = styled.div`
  margin-top: 20px;
  /* z-index: 10; */
`;

const ItemContainer = styled.div`
  width: 100%;
  margin-bottom: 26px;
  &:last-child {
    margin-bottom: 0px;
  }
`;

const ItemTitleBox = styled.a`
  width: 20%;
  height: 29px;
  margin-bottom: 6px;
`;

const ItemDescBox = styled.div`
  width: 100%;
  height: 43px;
  margin-bottom: 6px;
`;

const ItemSourceBox = styled.div`
  width: 100%;
  height: 20px;
`;

const SkeletonCard = () => {
  const makeList = (): ReactNode[] | null => {
    const resultReactNode: ReactNode[] | null = [];

    for (let index = 0; index < 10; index += 1) {
      resultReactNode.push(
        <ItemContainer>
          <ItemTitleBox>
            <Skeleton height={29} width="50%" />
          </ItemTitleBox>
          <ItemDescBox>
            <Skeleton height={43} width="100%" />
          </ItemDescBox>
          <ItemSourceBox>
            <Skeleton width="30%" />
          </ItemSourceBox>
        </ItemContainer>
      );
    }

    return resultReactNode;
  };
  return <SkeletonComponent>{makeList()}</SkeletonComponent>;
};
export default SkeletonCard;
